<section class="relative flex justify-center">
    <picture class="w-full">
        <source media="(min-width: 1024px)"
                srcset="https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/ayr_consciousmobility_1900@1x.avif 1920w,
                         https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/ayr_consciousmobility_1900@1x.webp 1920w,
                         https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/ayr_consciousmobility_1600@1x.avif 1440w,
                         https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/ayr_consciousmobility_1600@1x.webp 1440w,
                         https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/ayr_consciousmobility_1200@1x.avif 1024w,
                         https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/ayr_consciousmobility_1200@1x.webp 1024w,
                         https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/ayr_consciousmobility_768@1x.avif 640w,
                         https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/ayr_consciousmobility_768@1x.webp 640w"
                sizes="(max-width: 640px) 640px,
                       (max-width: 1024px) 1024px,
                       (max-width: 1440px) 1440px,
                       1920px" 
                type="image/avif">
        <img
            class="w-full"
            src="https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/ayr_consciousmobility_768@1x.webp"
            alt="ayr_cities" loading="lazy">
    </picture>
    <div class="max-w-960 inset-0 absolute z-10 m-auto flex justify-center sm:block">
        <h2 class="text-center text-27 lg:text-47 mt-4 lg:mt-14 text-white font-bold z-10 relative -white-text h-fit">
                {{'citizens.conscious-mobility.header.conscious' | translate}}
            <span class="ayr-underline dark:text-shadow">
                {{'citizens.conscious-mobility.header.mobility' | translate}}</span>
        </h2>
        <div
            class="max-w-[288px] sm:max-w-[400px] text-bold text-13 lg:text-18 absolute bottom-0 sm:left-0 bg-ayr-yellow-200 dark:bg-ayr-green-900 dark:text-ayr-white px-4 lg:px-14 py-10">
            <p> {{'citizens.conscious-mobility.content.first' | translate}} </p>
            <p class="mt-4"> {{'citizens.conscious-mobility.content.second' | translate}} </p>
        </div>
    </div>
</section>